export type Role = 'superadmin' | 'teamleider' | 'accountmanager' | 'recruiter';

export const routeForRole = (role: Role | string | null): string => {
  switch (role) {
    case 'superadmin':
      return '/superadmin';
    case 'teamleider':
      return '/teamleider';
    case 'accountmanager':
      return '/accountmanager';
    case 'recruiter':
      return '/recruiter';
    default:
      return '/dashboard';
  }
};

export const isValidRole = (role: string | null): role is Role => {
  return ['superadmin', 'teamleider', 'accountmanager', 'recruiter'].includes(role || '');
};
